import { render, staticRenderFns } from "./CompaniesList.vue?vue&type=template&id=137b54c0&"
import script from "./CompaniesList.vue?vue&type=script&lang=js&"
export * from "./CompaniesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports